import React, { PureComponent, ReactChild } from 'react'
import styled from 'styled-components'
import Toggle from '../../../components/toggle/Toggle'
import getFont from '../../../helpers/fonts/fonts'
import getPalette, { IPalette } from '../../../helpers/colors/colors'

const colors: IPalette = getPalette()

const Wrapper = styled.div`
	align-items: center;
	display: flex;
	text-align: left;
	padding: 8px 0;
	width: 90%;

	@media (min-width: ${600}px) {
		width: 280px;
	}
`

const Label = styled.div`
	width: 100%;
	color: ${colors.grayBlue};
	font-family: ${getFont('primaryMedium')};
	font-size: 14px;
	flex: 1 0 auto;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: pre-wrap;
	display: flex;
	.label__icon {
		width: 16px;
		height: 16px;
		color: ${colors.grayBlue};
		padding-top: 4px;
	}

	.label__span {
		margin-left: 5px;
		margin-top: 4px;
	}
`

const ToggleContainer = styled.div`
	flex: 0 0 auto;
`

interface IToggleProps {
	onChange: (id: string, value: string) => void
	value: string
	label: string
	id: string
	values: string[]
	icon: ReactChild
	disabled?: boolean
}

class SettingsToggle extends PureComponent<IToggleProps> {
	static defaultProps = {
		value: '0',
		disabled: false,
	}

	onChange = (value: string) => {
		if (this.props.id === 'isTimerDisabled') {
			const newValue = value === '1' ? this.props.values[1] : this.props.values[0]
			this.props.onChange(this.props.id, newValue)
		} else {
			this.props.onChange(this.props.id, this.props.values[parseInt(value)])
		}
	}

	getValue() {
		if (this.props.id === 'isTimerDisabled') {
			return this.props.value === this.props.values[0] ? '0' : '1'
		}
		return this.props.values.findIndex((value: any) => value === this.props.value).toString()
	}

	render() {
		const value = this.getValue()
		return (
			<Wrapper>
				<Label>
					{this.props.icon}
					<span className='label__span'>{this.props.label}</span>
				</Label>
				<ToggleContainer>
					<Toggle value={value} onChange={this.onChange} disabled={this.props.disabled} />
				</ToggleContainer>
			</Wrapper>
		)
	}
}

export default SettingsToggle
